export var WorkspaceStatus;
(function (WorkspaceStatus) {
    WorkspaceStatus["WORKSPACE_STATUS_PROVISIONING"] = "PROVISIONING";
    WorkspaceStatus["WORKSPACE_STATUS_ACTIVE"] = "ACTIVE";
    WorkspaceStatus["WORKSPACE_STATUS_FAILED"] = "FAILED";
})(WorkspaceStatus || (WorkspaceStatus = {}));
